"use client";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Trash2, X, Menu } from 'lucide-react';
import AddressAutocomplete from "./AddressAutocomplete";
import { Coordinates } from "../../types/distance.types";

interface SortableItemProps {
  id: string;
  value: string;
  onChange: (val: string, coords?: Coordinates) => void;
  onRemove: () => void;
  onClear: () => void;
  isDimmed?: boolean;
  placeholder: string
}

export function SortableItem({ 
    id, 
    value, 
    onChange, 
    onRemove, 
    onClear,
    isDimmed,
    placeholder="", 
}: SortableItemProps) {

  const { 
    attributes, 
    listeners, 
    setNodeRef, 
    transform 
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transform ? "transform 200ms ease" : "none",
  };

  return (
    <div 
      ref={setNodeRef} 
      style={style} 
      className={`sortable-row ${isDimmed ? "sortable-dimmed-row" : ""}`}
    >
      <span
        {...listeners}
        {...attributes}
        onTouchStart={(e) => e.preventDefault()}
      >
        <Menu className="sortable-grip"/>
      </span>

      <div className="autocomplete-with-clear">
        <AddressAutocomplete
          value={value}
          placeholder={placeholder}
          disabled={isDimmed}
          onSelect={(address, coords) => onChange(address, coords)}
        />

        <button
          onClick={onClear}
          className="close-btn clear-icon"
          tabIndex={-1}
          aria-label="Clear input"
        >
          <X className="sortable-clear-btn"/>
        </button>
      </div>
      <button 
        onClick={onRemove} 
        className="close-btn"
        aria-label="Remove item"
      >
        <Trash2 className="sortable-remove-btn"/>
      </button>
    </div>
  );
}
